/** Pure barrel — re-exports only side-effect-free modules */
export * from "./aggregatorBlock.pure";
export * from "./latticeBlock.pure";
export * from "./setColorsBlock.pure";
export * from "./setMaterialIDBlock.pure";
export * from "./setNormalsBlock.pure";
export * from "./setPositionsBlock.pure";
export * from "./setTangentsBlock.pure";
export * from "./setUVsBlock.pure";
